import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WebSocketMessage } from '../../../models/websocketMessage.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WsService {
  private socket: WebSocket | null = null
  private connectionStatus = new BehaviorSubject<'connected' | 'disconnected' | 'connecting'>('disconnected');
  private messageSubject = new Subject<WebSocketMessage>();
  private messageStreams = new Map<string, Subject<any>>();

  constructor() { }

  connect(token: string) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      return;
    }

    this.connectionStatus.next('connecting');
    const wUrl = `${environment.wsUrl}?token=${token}`;

    this.socket = new WebSocket(wUrl);

    this.socket.onopen = (event: any) => {
      this.connectionStatus.next('connected');
      console.log('WebSocket connection opened');
    };

    this.socket.onmessage = (event: any) => {
      try {
        const message = JSON.parse(event.data) as WebSocketMessage;

        this.messageSubject.next(message);

        if (!this.messageStreams.has(message.type)) {
          this.messageStreams.set(message.type, new Subject())
        }
        this.messageStreams.get(message.type)?.next(message.data);
      } catch (error) {
        console.error(`Failed to parse message:`, error)
      }
    };

    this.socket.onclose = (event) => {
      console.error(`WebSocket disconnected:`, event.code, event.reason);

      setTimeout(() => {
        if (this.connectionStatus.value !== 'connected') {
          this.connect(token);
        }
      }, 3000)
    };

    this.socket.onerror = (error) => {
      console.error(`Websocket error:`, error)
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.close(1000, 'User disconnected');
      this.socket = null;
    }
    this.connectionStatus.next('disconnected');
  }

  getConnectionStatus() {
    return this.connectionStatus.asObservable();
  }

  isConnected() {
    return this.socket?.readyState === WebSocket.OPEN;
  }

  on<T>(type: string): Observable<T> {
    if (!this.messageStreams.has(type)) {
      this.messageStreams.set(type, new Subject())
    }
    return this.messageStreams.get(type)!.asObservable();
  }
}
